<template>
    <div>
        <div class="d-flex flex-row mb-3">
            <div class="h5 flex-grow-1" >Смена пароля</div>

            <div class="d-flex">
                <div class="flex-grow-0">
                    <b-button variant="outline-secondary" size="lg" class="border-0 p-0"  @click="onCancel">
                        <b-icon icon="x" />
                    </b-button>
                </div>
            </div>
        </div>

        <div class="modal-inner">
            <b-form @submit.stop.prevent="onSubmit()">

                <transition name="fade" mode="out-in">
                    <div class="d-flex flex-column mb-3" v-if="failMessages.length">
                        <span class="text-danger" v-for="(failMessage, i) in failMessages">{{ failMessage }}</span>
                    </div>
                </transition>

                <b-form-group
                    id="newPassword-group"
                    label="Новый пароль"
                    label-for="newPassword">
                    <b-form-input
                        id="newPassword"
                        v-model="$v.form.newPassword.$model"
                        type="password"
                        :state="validateState('newPassword')"
                        aria-describedby="newPassword-live-feedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="newPassword-live-feedback">{{ validationMessageText($v.form.newPassword) }}</b-form-invalid-feedback>
                    <b-form-invalid-feedback id="newPassword-server-feedback" :state="!errors.newPassword.length">
                        <span class="text-danger" v-for="(failMessage, i) in errors.newPassword">{{ failMessage }}</span>
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group
                    class="mb-5"
                    id="confirmPassword-group"
                    label="Повторите пароль"
                    label-for="confirmPassword">
                    <b-form-input
                        id="confirmPassword"
                        v-model="$v.form.confirmPassword.$model"
                        type="password"
                        :state="validateState('confirmPassword')"
                        aria-describedby="confirmPassword-live-feedback">
                    </b-form-input>

                    <b-form-invalid-feedback id="confirmPassword-live-feedback">{{ validationMessageText($v.form.confirmPassword) }}</b-form-invalid-feedback>
                    <b-form-invalid-feedback id="confirmPassword-server-feedback" :state="!errors.confirmPassword.length">
                        <span class="text-danger" v-for="(failMessage, i) in errors.confirmPassword">{{ failMessage }}</span>
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-button block type="submit" variant="primary" :disabled="$v.$anyError">Поменять</b-button>
            </b-form>
        </div>
    </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import FormField from "@/components/Forms/FormField.vue";
import {validationMessage} from "vuelidate-messages";
import {formMessages} from "@/utils/validationMessages";
import httpClient from "@/http";

export default {
    name: "PasswordChangeForm",
    components: {FormField},
    mixins: [ validationMixin ],
    data() {
        return {
            form: {
                newPassword: null,
                confirmPassword: null
            },
            errors: {
                newPassword: [],
                confirmPassword: []
            },
            failMessages: []
        }
    },
    validations: {
        form: {
            newPassword: { required },
            confirmPassword: { required },
        }
    },
    methods: {
        validationMessageText: validationMessage(formMessages, {dirty: true, first: 1}),
        validateState(name) {
            if (this.errors[name].length) { return false }
            const { $dirty, $error } = this.$v.form[name];
            return  $dirty ? !$error : null;
        },
        onCancel() {
            this.$emit('modal-closed');
        },
        reset() {
            this.errors.newPassword = [];
            this.errors.confirmPassword = [];
            this.$emit('form-error-reset');
        },
        onSubmit() {
            const vm = this;
            const url = '/accounts/change-password/'
            const data = {
                'new_password':  this.form.newPassword,
                'confirm_password': this.form.confirmPassword
            }
            vm.reset();
            httpClient.post(url, data)
                .then(response => {
                    vm.$bvToast.toast('Пароль успешно изменен', {title: 'Смена пароля', autoHideDelay: 5000, variant: 'success'})
                })
                .catch(reason => {
                    if (reason.response !== undefined && reason.response.data !== undefined) {
                        const data = reason.response.data
                        const nonFieldErrors = data['non_field_errors']
                        if (Array.isArray(nonFieldErrors)) {
                            vm.failMessages = [...nonFieldErrors];
                        }
                        if (data['new_password']) {
                            vm.errors.newPassword = [...data['new_password']];
                        }
                        if (data['confirm_password']) {
                            vm.errors.confirmPassword = [...data['confirm_password']]
                        }
                        if (vm.failMessages.length) {
                            vm.$emit('form-error-received');
                        }

                    }
                })
        }
    }
}
</script>

<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity .6s ease-out;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>